import {Component, Input, OnInit} from '@angular/core';
import {
  BerlinBrandenBurgKurzBericht,
  BerlinBrandenBurgOnlineBericht
} from "../../../../../../../../model/vorhersagen/rbb-document";

@Component({
  selector: 'app-berlin-brandenburg-online-bericht',
  templateUrl: './berlin-brandenburg-online-bericht.component.html',
  styleUrls: ['./berlin-brandenburg-online-bericht.component.css','../../../wetterbericht.component.css']
})
export class BerlinBrandenburgOnlineBerichtComponent {
  @Input()
  berlinBrandenburgOnlineBericht?: BerlinBrandenBurgOnlineBericht;


}
